﻿define(
//begin v1.x content
({
	invalidMessage: "Giá trị được nhập không hợp lệ.",
	missingMessage: "Giá trị này là bắt buộc.",
	rangeMessage: "Giá trị này ngoài phạm vi."
})
//end v1.x content
);
